module.exports = __webpack_public_path__ + "static/media/ir.1348920d.svg";